import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'PAYMENTS_SHOW_ERROR':
      return action.error;

    case 'PAYMENTS_SHOW_MERCURE_DELETED':
      return `${action.retrieved['@id']} has been deleted by another user.`;

    case 'PAYMENTS_SHOW_RESET':
      return null;

    case 'VOUCHER_SHOW_ERROR':
      return action.error;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'PAYMENTS_SHOW_LOADING':
      return action.loading;

    case 'PAYMENTS_SHOW_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'PAYMENTS_SHOW_SUCCESS':
    case 'PAYMENTS_SHOW_MERCURE_MESSAGE':
      return action.retrieved;

    case 'PAYMENTS_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved });
